<!--
 * @Author: guoyu
 * @Date: 2020-04-28 12:39:24
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:35:29
 * @Description: 综合评分B端用户解释弹窗
 -->
<template>
  <el-dialog
    :visible.sync="popupShow"
    class="explain-container"
    custom-class="dialog-clear-style explain-container-wrap"
    :show-close="false"
    top="50vh"
    width="375px"
    append-to-body
    @close="$emit('close', false)"
  >
    <header class="explain-title">
      <fps-icon class="explain-close" type="close" @click.native="$emit('close', false)" />{{$t('upgrade_page_views_master_index_210')}}</header>
    <div class="score-explain">
      <div class="container">
        <scoreCard :score="score" ref="cardRef"></scoreCard>
        <div class="explain">
          <div class="title">
            <img src="~@/assets/images/light.png" />{{$t('components_scoreexplain_score2_explain_popup_1827')}}</div>
          <div class="list">
            <h3>{{$t('upgrade_page_views_dashboard_index_1436')}}</h3>
            <p>{{$t('components_scoreexplain_score2_explain_popup_1828')}}</p>
            <h3>{{$t('components_scoreexplain_score2_explain_popup_1829')}}</h3>
            <p>{{$t('components_scoreexplain_score2_explain_popup_1830')}}</p>
            <h3>{{$t('components_scoreexplain_score2_explain_popup_1831')}}</h3>
            <p>{{$t('components_scoreexplain_score2_explain_popup_1832')}}</p>
            <ul>
              <li>{{$t('components_scoreexplain_score2_explain_popup_1833')}}<dl>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1834')}}</dd>
                </dl>
              </li>
              <li>{{$t('components_scoreexplain_score2_explain_popup_1835')}}<dl>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1836')}}</dd>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1837')}}</dd>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1838')}}</dd>
                </dl>
              </li>
              <li>{{$t('components_scoreexplain_score2_explain_popup_1839')}}<dl>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1840')}}</dd>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1841')}}</dd>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1842')}}</dd>
                </dl>
              </li>
              <li>{{$t('components_scoreexplain_score2_explain_popup_1843')}}<dl>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1844')}}</dd>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1845')}}</dd>
                </dl>
              </li>
              <li>{{$t('components_scoreexplain_score2_explain_popup_1846')}}<dl>
                  <dd>{{$t('components_scoreexplain_score2_explain_popup_1847')}}</dd>
                </dl>
              </li>
            </ul>
            <h3>{{$t('components_scoreexplain_score2_explain_popup_1848')}}</h3>
            <dl>
              <dt>{{$t('components_scoreexplain_score2_explain_popup_1849')}}</dt>
              <dd>{{$t('components_scoreexplain_score2_explain_popup_1850')}}</dd>
              <dd>{{$t('components_scoreexplain_score2_explain_popup_1851')}}</dd>
            </dl>
          </div>
          <p>{{$t('components_scoreexplain_score2_explain_popup_1852')}}</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import scoreCard from './score-card.vue';
export default {
  components: { scoreCard },
  model: {
    event: 'close',
    prop: 'show',
  },
  data() {
    return {
      isPC: true,
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 移动端从底部弹出
    popupPosition() {
      if(this.isPC) {
        return ''
      }
      return 'bottom'
    },
    popupShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit('close', newVal);
      },
    },
  },
  watch: {
    popupShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.cardRef.animate();
        });
      }
    },
  },
  methods: {
    judgePlatform() {
      if(window.innerWidth>=600) {
        this.isPC = true
      } else {
        this.isPC = false
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.cardRef.animate();
    });
    this.judgePlatform()
  }
};
</script>
<style lang="scss" scoped>
  .explain-container {
    & /deep/ .explain-container-wrap {
      .el-dialog__body {
        background: #fff;
        border-radius: 8px;
        width: 375px;
        border-radius: 8px;
        text-align: left;
        transform: translateY(-50%);
        max-height: 500px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .explain-title {
    position: relative;
    width: 100%;
    padding: 18px 20px;
    border-bottom: solid 1px #E3E3E3;
    line-height: 1;
    font-weight: 600;
    font-size: 16px;
    color: #171717;
    background: #fff;
  }
  .explain-close {
    position: absolute;
    right: 23px;
    top: 17px;
    font-size: 18px;
    color: $color-gray-3;
    cursor: pointer;
  }

  .score-explain {
    position: relative;
    z-index: 0;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    .container {
      padding: 0 20px;
      position: relative;
    }
    .score {
      width: 100%;
      height: 70px;
      line-height: 70px;
      color: #333;
      font-size: 14px;
      span {
        font-size: 18px;
        font-weight: 500;
        margin-left: 15px;
      }
    }
    .explain {
      margin-top: 30px;
      .title {
        @include flex;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        padding-right: 10px;
        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }
      p {
        color: #999;
        font-size: 14px;
        line-height: 20px;
        text-align: left;
      }
      .list {
        border-top: 1PX solid #F4F4F4;
        border-bottom: 1PX solid #F4F4F4;
        margin-top: 25px;
        padding-bottom: 25px;
        overflow: hidden;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        h3 {
          margin: 25px 0 12px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
        ul {
          li {
            list-style: decimal inside;
            color: #333;
            font-weight: 500;
            margin-top: 25px;
          }
        }
        dl {
          margin-top: 12px;
          dt {
            color: #333;
          }
          dd {
            color: #999;
            font-weight: normal;
            margin-top: 12px;
            &::before {
              content: '• ';
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
      > p {
        margin: 25px 0 30px;
      }
    }
  }
</style>
